import React, { useState } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { CompletionAndDismantling } from '../../../api';
import LabelAndTextBox from '../../molecules/labelandtextbox/LabelAndTextBox';
import './CompletionAndDismantling.css';
import DateBox from "../../molecules/labelandtextbox/DateBox";

interface CompletionAndDismantlingProp {
    completionAndDismantling: CompletionAndDismantling;
    onUpdate?: (updatedData: Partial<CompletionAndDismantling>) => void;
}

const CompletionAndDismantlingSection: React.FC<CompletionAndDismantlingProp> = (props) => {
    const updateCompletionAndDismantling = (updatedData: Partial<CompletionAndDismantling>) => {
        Object.assign(props.completionAndDismantling, updatedData);
        props.onUpdate?.(updatedData);
    };

    const [jaChecked, setJaChecked] = useState<boolean>(props.completionAndDismantling?.doesTheWeatherProtectionNeedToBeAccessedDuringThePeriodOfUse || false);
    const [nejChecked, setNejChecked] = useState<boolean>(!props.completionAndDismantling?.doesTheWeatherProtectionNeedToBeAccessedDuringThePeriodOfUse || false);

    const handleJaCheckboxChange = () => {
        setJaChecked(true);
        setNejChecked(false);
        updateCompletionAndDismantling({ doesTheWeatherProtectionNeedToBeAccessedDuringThePeriodOfUse: true });
    };

    const handleNejCheckboxChange = () => {
        setJaChecked(false);
        setNejChecked(true);
        updateCompletionAndDismantling({ doesTheWeatherProtectionNeedToBeAccessedDuringThePeriodOfUse: false });
    };

    return (
        <Container className='align-items-center tablecolor'>
            <Row>
                <Col xs={12} md={6} lg={12}>
                    <div className='header-section-5-input mb-5'>
                        <h3>5. Uppförande och nedmontering</h3>
                    </div>
                </Col>
                <Col xs={12}>
                    <DateBox
                        defaultValue={props.completionAndDismantling.dateTimeForCompletion}
                        title='Tidpunkt för uppförande'
                        onChange={(value) => {
                            updateCompletionAndDismantling({ dateTimeForCompletion: value.toISOString() });
                        }} />
                </Col>
                <Col xs={12}>
                    <DateBox
                        defaultValue={props.completionAndDismantling.dateTimeForDismantling}
                        title='Planerad tidpunkt för nedmontering'
                        onChange={(value) => {
                            updateCompletionAndDismantling({ dateTimeForDismantling: value.toISOString() });
                        }} />
                </Col>
                <Col xs={12}>
                    <DateBox
                        defaultValue={props.completionAndDismantling.dateTimeForSignificantChange}
                        title='Tidpunkt för väsentlig ändring (specificera)'
                        onChange={(value) => {
                            updateCompletionAndDismantling({ dateTimeForSignificantChange: value.toISOString() });
                        }} />
                </Col>
                <Col xs={12} md={6} lg={12}>
                    <LabelAndTextBox title='Ställningen/väderskyddet kommer att avgränsas på följande sätt under uppförande och nedmontering' remark={props.completionAndDismantling?.scaffoldWillBeDelineatedAsFollowsDuringConstructionAndDismantling}
                        onChange={(value) => {
                            updateCompletionAndDismantling({ scaffoldWillBeDelineatedAsFollowsDuringConstructionAndDismantling: value });
                        }} />
                </Col>
                <Col xs={12}>
                    <h4 className="mt-5">Metod för upp- och nedtransport av material till ställningen/väderskyddet:</h4>
                </Col>
                <Col>
                    <div className='checkboxes1 mt-4'>
                        <input type="checkbox" name="kran" defaultChecked={props.completionAndDismantling?.methodCrane}
                            onChange={() => {
                                updateCompletionAndDismantling({ methodCrane: !props.completionAndDismantling.methodCrane });
                            }} />
                        <label>Kran</label>
                        <input type="checkbox" defaultChecked={props.completionAndDismantling?.methodMaterialElevator}
                            onChange={() => {
                                updateCompletionAndDismantling({ methodMaterialElevator: !props.completionAndDismantling.methodMaterialElevator });
                            }} />
                        <label>Materialhiss</label>
                        <input type="checkbox" defaultChecked={props.completionAndDismantling?.methodManualLiftDevice}
                            onChange={() => {
                                updateCompletionAndDismantling({ methodManualLiftDevice: !props.completionAndDismantling.methodManualLiftDevice });
                            }} />
                        <label>Manuell lyftanordning(t.ex. lyftblock)</label>
                        <input type="checkbox" defaultChecked={props.completionAndDismantling?.methodOther}
                            onChange={() => {
                                updateCompletionAndDismantling({ methodOther: !props.completionAndDismantling.methodOther });
                            }} />
                        <label>Annan maskinell lyftanordning <br /> (wirespel e.dyl.)</label>
                    </div>
                </Col>
                <Col xs={12}>
                    <LabelAndTextBox title='Annan metod (ange vilken)' remark={props.completionAndDismantling?.methodOtherDescription}
                        onChange={(value) => {
                            updateCompletionAndDismantling({ methodOtherDescription: value });
                        }} />
                </Col>
                <Col xs={12}>
                    <h4 className="mt-5">Skydd mot fall (för de som uppför eller monterar ned ställningen/väderskyddet):</h4>
                </Col>
                <Col>
                    <div className='checkboxes1 mt-4'>
                        <input type="checkbox" name="kran" defaultChecked={props.completionAndDismantling?.scaffoldProtectionRailing}
                            onChange={() => {
                                updateCompletionAndDismantling({ scaffoldProtectionRailing: !props.completionAndDismantling.scaffoldProtectionRailing });
                            }} />
                        <label>Ställningsräcke, som monteras innan resp.<br /> plan beträds (endast möjligt för vissa- <br /> fabrikat)</label>
                        <input type="checkbox" defaultChecked={props.completionAndDismantling?.temporaryProtectionRailing}
                            onChange={() => {
                                updateCompletionAndDismantling({ temporaryProtectionRailing: !props.completionAndDismantling.temporaryProtectionRailing });
                            }} />
                        <label>Temporärt skyddsräcke</label>
                        <input type="checkbox" defaultChecked={props.completionAndDismantling?.personalProtectionEquipment}
                            onChange={() => {
                                updateCompletionAndDismantling({ personalProtectionEquipment: !props.completionAndDismantling.personalProtectionEquipment });
                            }} />
                        <label>Personlig skyddsutrustning</label>
                    </div>
                </Col>
                <Col xs={12}>
                    <LabelAndTextBox title='Annat (ange vilket skydd)' remark={props.completionAndDismantling?.otherProtection}
                        onChange={(value) => {
                            updateCompletionAndDismantling({ otherProtection: value });
                        }} />
                </Col>
                <Col>
                    <div className='paragraf-section-2 mt-4'>
                        <p>Behöver väderskyddet beträdas under användningstiden?</p>
                    </div>
                    <div className='checkboxes'>
                        <input
                            type="checkbox"
                            checked={jaChecked}
                            onChange={handleJaCheckboxChange}
                        />
                        <label>Ja</label>
                        <input
                            type="checkbox"
                            checked={nejChecked}
                            onChange={handleNejCheckboxChange}
                        />
                        <label>Nej</label>
                    </div>
                    <div className='paragraf-section-2 mt-4'>
                        <p>Om ja, ange skydd mot fall då väderskyddet beträdas:</p>
                    </div>
                    <div className='checkboxes'>
                        <input type="checkbox" defaultChecked={props.completionAndDismantling?.ifAccessedDuringUseProtectionRailing}
                            onChange={() => {
                                updateCompletionAndDismantling({ ifAccessedDuringUseProtectionRailing: !props.completionAndDismantling.ifAccessedDuringUseProtectionRailing });
                            }} />
                        <label>Skyddsräcke</label>
                        <input type="checkbox" defaultChecked={props.completionAndDismantling?.ifAccessedDuringUsePersonalSafetyEquipment}
                            onChange={() => {
                                updateCompletionAndDismantling({ ifAccessedDuringUsePersonalSafetyEquipment: !props.completionAndDismantling.ifAccessedDuringUsePersonalSafetyEquipment });
                            }} />
                        <label>Personlig-<br />skyddsutrustning</label>
                    </div>
                </Col>
                <Col xs={12}>
                    <LabelAndTextBox title='Annat (ange vilket skydd)' remark={props.completionAndDismantling?.ifAccessedDuringUseOther}
                        onChange={(value) => {
                            updateCompletionAndDismantling({ ifAccessedDuringUseOther: value });
                        }} />
                </Col>
            </Row>
            <hr />
        </Container>
    );
};

export default CompletionAndDismantlingSection;
